/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_Method_Change_ErrorInputs */

const vi_order_payment_method_change_error = /** @type {(inputs: Order_Payment_Method_Change_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi hình thức thanh toán thất bại`)
};

/**

* @param {Order_Payment_Method_Change_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_error = /** @type {((inputs?: Order_Payment_Method_Change_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_error(inputs)
});